import useAnalytics from '../hooks/useAnalytics';

// Wrapper component to initialize analytics inside Router context
const AnalyticsWrapper = ({ children }) => {
  // Initialize visit tracking for analytics
  useAnalytics();
  
  return children;
};

export default AnalyticsWrapper;
